/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-07-14T10:58:26.244
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	getFinancialEvidenceItemEditInit,
	getFinancialEvidenceItemView
} from '@api/financial/FinancialEvidenceItem';

import {
listFinancialEvidenceDetailInit,
listFinancialEvidenceDetailByAuthorizations,
deleteFinancialEvidenceDetail
} from '@api/financial/FinancialEvidenceDetail';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
		AdvanceQuery: cloneObj(RespCommonDef.AdvanceQuery)
	},
	actions: {
		getFinancialEvidenceItemEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getFinancialEvidenceItemEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getFinancialEvidenceItemView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getFinancialEvidenceItemView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
	}
};
